// ../db2/src/enums.ts
var MovementType = {
  SALE: "SALE",
  RESTOCK: "RESTOCK",
  ADJUSTMENT: "ADJUSTMENT",
  RETURN: "RETURN"
};
var ImageEntity = {
  product: "product",
  section: "section",
  collection: "collection",
  announcement: "announcement",
  brand: "brand"
};
var announcementEntity = {
  product: "product",
  section: "section",
  collection: "collection"
};
var OrderStatus = {
  pending: "pending",
  confirmed: "confirmed",
  preparing: "preparing",
  out_for_delivery: "out_for_delivery",
  delivered: "delivered",
  cancelled: "cancelled",
  rejected: "rejected",
  delivery_failed: "delivery_failed"
};
var OrderSource = {
  app: "app",
  phone: "phone",
  whatsapp: "whatsapp",
  pos: "pos",
  manual: "manual"
};
var ShiftStatus = {
  open: "open",
  pending: "pending",
  confirmed: "confirmed"
};
var ProductType = {
  STANDARD_PRODUCT: "STANDARD_PRODUCT",
  LOCAL_PRODUCT: "LOCAL_PRODUCT",
  WEIGHT_PRODUCT: "WEIGHT_PRODUCT",
  WEIGHT_DEFINED_PRODUCT: "WEIGHT_DEFINED_PRODUCT"
};
var CustomerReturnStatus = {
  active: "active",
  cancelled: "cancelled"
};
var Status = {
  active: "active",
  inactive: "inactive"
};
var PaymentMethod = {
  cash: "cash",
  card: "card",
  wallet: "wallet"
};
var CustomerTransactionType = {
  PAYMENT: "PAYMENT",
  ORDER_DEBT: "ORDER_DEBT",
  REFUND: "REFUND",
  ADJUSTMENT: "ADJUSTMENT"
};

// src/index.ts
import { z as z10 } from "zod/v4-mini";

// src/utils.ts
import { z } from "zod/v4-mini";
var expoImage = z.object({
  blob: z.instanceof(Blob),
  fileName: z.optional(z.string()),
  height: z.optional(z.number()),
  mimeType: z.optional(z.string()),
  uri: z.string(),
  width: z.optional(z.number())
});
function enumValues(e) {
  return Object.values(e);
}

// src/pos.ts
import { PaymentMethod as PaymentMethod2, InboxType, OrderSource as OrderSource2 } from "@white-labels/db2";
import { z as z2 } from "zod/v4-mini";
var posLoginInput = z2.object({
  username: z2.string().check(z2.minLength(2)),
  password: z2.string().check(z2.minLength(2))
});
var syncChangesInput = z2.object({
  sinceSeq: z2.number(),
  limit: z2._default(z2.number(), 200)
});
var identifyPos = z2.object({
  deviceId: z2.string()
});
var getProductByUpcInput = z2.object({
  upc: z2.string()
});
var lookupInput = z2.object({
  search: z2.string()
});
var startShiftInput = z2.object({
  type: z2.literal(InboxType.shift_start),
  hash: z2.string(),
  employeeId: z2.number(),
  openingCash: z2.number(),
  startTime: z2.number()
});
var endShiftInput = z2.object({
  type: z2.literal(InboxType.shift_end),
  hash: z2.string(),
  endTime: z2.number(),
  cash: z2.number(),
  visa: z2.number(),
  wallet: z2.number(),
  numberOfReceipts: z2.number(),
  source: z2._default(z2.enum(OrderSource2), "pos")
});
var itemInput = z2.object({
  productId: z2.number(),
  upc: z2.string(),
  name: z2.string(),
  quantity: z2.number(),
  price: z2.number(),
  total: z2.number(),
  originalPrice: z2.optional(z2.number()),
  weight: z2.optional(z2.number()),
  pricePerKg: z2.optional(z2.number()),
  saleMethod: z2._default(z2.enum(OrderSource2), "pos"),
  originalPricePerKg: z2.optional(z2.number())
});
var createReceiptInput = z2.object({
  type: z2.literal(InboxType.receipt_new),
  hash: z2.string(),
  number: z2.number(),
  discount: z2.optional(z2.number()),
  paid: z2.number(),
  amount: z2.number(),
  paymentMethod: z2.enum(PaymentMethod2),
  note: z2.optional(z2.string()),
  shiftHash: z2.string(),
  items: z2.array(itemInput),
  time: z2.number()
});
var Event = z2.object({
  payload: z2.union([startShiftInput, endShiftInput, createReceiptInput]),
  seq: z2.number(),
  time: z2.number()
});
var ingestBatchInput = z2.object({
  deviceId: z2.string(),
  events: z2.array(Event)
});

// src/m5azen.ts
import { z as z3 } from "zod/v4-mini";
import { zfd } from "zod-form-data";
var listProductsInput = z3.object({
  // type: z.optional(z.enum(ProductType)),
  types: z3.optional(z3.array(z3.enum(ProductType))),
  limit: z3._default(z3.optional(z3.number()), 100),
  collectionId: z3.optional(z3.number()),
  // cursor: z.optional(z.number()),
  cursor: z3.optional(z3.object({ id: z3.number(), rank: z3.number(), updatedAt: z3.optional(z3.number()) })),
  brandId: z3.optional(z3.number()),
  search: z3.optional(z3.string()),
  //
  onlyBaseProducts: z3.optional(z3.boolean()),
  inventoryCollectionIds: z3.optional(z3.array(z3.number())),
  status: z3._default(z3.optional(z3.array(z3.enum(Status))), ["active"])
});
var listProductsByStoragePlaceInput = z3.object({
  ...listProductsInput.shape,
  storagePlaceId: z3.number(),
  sortByLatestUpdate: z3.optional(z3.boolean())
});
var listDenormalizedProductsInput = z3.object({
  storagePlaceId: z3.number()
});
var normalizeProductInput = z3.object({
  storagePlaceId: z3.number(),
  baseProductId: z3.number()
});
var getProductInput = z3.union([
  z3.object({ id: z3.number() })
  //
]);
var getProductMultiple = z3.object({
  ids: z3.array(z3.number())
});
var editMenuSettingsInput = z3.object({
  id: z3.number(),
  listedInApp: z3.optional(z3.boolean()),
  isAvailable: z3.optional(z3.boolean()),
  canExceedInventory: z3.optional(z3.boolean()),
  maxOrderQuantity: z3.optional(z3.number().check(z3.int(), z3.minimum(1))),
  price: z3.optional(z3.number().check(z3.int(), z3.minimum(0))),
  originalPrice: z3.optional(z3.number().check(z3.int(), z3.minimum(0)))
});
var _productFormInput = z3.object({
  id: z3.optional(z3.number()),
  name: z3.string().check(z3.minLength(3)),
  description: z3.optional(z3.string()),
  type: z3.enum(["STANDARD_PRODUCT", "LOCAL_PRODUCT", "WEIGHT_PRODUCT"]),
  upc: z3.string(),
  baseUpc: z3.optional(z3.string()),
  cost: z3.optional(z3.number().check(z3.int(), z3.minimum(0))),
  price: z3.number().check(z3.int(), z3.minimum(0)),
  originalPrice: z3.optional(z3.number().check(z3.int(), z3.minimum(0))),
  value: z3.optional(z3.number().check(z3.int(), z3.positive())),
  brandId: z3.optional(z3.number()),
  //
  inventoryCollections: z3.optional(z3.array(z3.number())),
  // Menu-related fields (optional)
  listedInApp: z3.optional(z3.boolean()),
  isAvailable: z3.optional(z3.boolean()),
  canExceedInventory: z3.optional(z3.boolean()),
  maxOrderQuantity: z3.optional(z3.number().check(z3.int(), z3.minimum(1)))
});
var productFormInput = _productFormInput.check(z3.refine((value) => value.upc !== value.baseUpc, "UPC and Base UPC cannot be the same"));
var productEditFormInput = z3.extend(_productFormInput, { id: z3.number() }).check(z3.refine((value) => value.upc !== value.baseUpc, "UPC and Base UPC cannot be the same"));
var productFormSchema = z3.object({
  sku: z3.string().check(z3.minLength(2, "SKU is required")),
  quantity: z3.coerce.number().check(z3.positive()),
  cost: z3.coerce.number().check(z3.positive()),
  suggestedPrice: z3.coerce.number().check(z3.positive())
});
var purchaseTransactionBase = {
  supplierId: z3.number("Supplier is required"),
  storagePlaceId: z3._default(z3.number("Storage place is required"), 0),
  products: z3.array(productFormSchema).check(z3.minLength(1, "At least one product is required")),
  discount: z3.optional(z3.number().check(z3.minimum(0))),
  notes: z3.optional(z3.string()),
  createdAt: z3.optional(z3.number())
};
var transactionListInput = z3.object({
  fromDate: z3.optional(z3.number()),
  toDate: z3.optional(z3.number()),
  supplierId: z3.optional(z3.number()),
  status: z3.optional(z3.enum(["active", "cancelled"])),
  cursor: z3.optional(z3.number()),
  limit: z3.optional(z3.number())
});
var TransactionTypeEnum = ["purchase", "return"];
var purchaseTransactionFormSchema = z3.object({
  type: z3._default(z3.enum(TransactionTypeEnum), "purchase"),
  ...purchaseTransactionBase
});
var EMPLOYEE_ROLES = ["cashier", "worker", "admin", "employee"];
var createEmployeeInput = z3.object({
  name: z3.string().check(z3.minLength(1, "Name is required")),
  username: z3.string().check(z3.minLength(1, "Username is required")),
  password: z3.string().check(z3.minLength(6, "Password must be at least 6 characters")),
  role: z3.enum(EMPLOYEE_ROLES)
});
var updateEmployeeInput = z3.extend(createEmployeeInput, {
  id: z3.number()
});
var getEmployeeInput = z3.object({
  id: z3.number()
});
var deleteEmployeeInput = z3.object({
  id: z3.number()
});
var addEmployeeBalanceInput = z3.object({
  employeeId: z3.number(),
  amount: z3.number().check(z3.positive()),
  notes: z3.optional(z3.string()),
  createdAt: z3.optional(z3.number())
});
var employeePayment = z3.object({
  employeeId: z3.number(),
  amount: z3.number().check(z3.positive()),
  notes: z3.optional(z3.string()),
  createdAt: z3.optional(z3.number())
});
var listShiftInput = z3.object({
  cursor: z3.optional(z3.object({ id: z3.number() })),
  limit: z3._default(z3.number(), 50),
  from: z3.optional(z3.number()),
  to: z3.optional(z3.number()),
  status: z3.optional(z3.enum(ShiftStatus))
});
var createShiftInput = z3.object({
  employeeId: z3.number(),
  startTime: z3.number(),
  endTime: z3.number(),
  cash: z3.number(),
  visa: z3.number(),
  wallet: z3.number()
});
var updateShiftInput = z3.extend(createShiftInput, {
  id: z3.number()
});
var getShiftInput = z3.object({
  id: z3.number()
});
var deleteShiftInput = z3.object({
  id: z3.number()
});
var confirmShiftInput = z3.object({
  id: z3.number(),
  actualCash: z3.number().check(z3.minimum(0)),
  actualVisa: z3.number().check(z3.minimum(0)),
  actualWallet: z3.number().check(z3.minimum(0)),
  confirmationNote: z3.optional(z3.string())
});
var shiftRangeInput = z3.object({
  from: z3.optional(z3.number()),
  to: z3.optional(z3.number())
});
var createExpenseInput = z3.object({
  amount: z3.number().check(z3.gt(0)),
  category: z3.number(),
  balanceType: z3.enum(["cash", "visa", "wallet"]),
  date: z3.optional(z3.number()),
  notes: z3.optional(z3.string())
});
var createExpenseCategoryInput = z3.object({
  name: z3.string().check(z3.trim(), z3.minLength(1), z3.maxLength(60)),
  color: z3.optional(z3.string().check(z3.regex(/^#[0-9A-Fa-f]{6}$/)))
});
var createSupplierPaymentInput = z3.object({
  supplierId: z3.number(),
  amount: z3.number().check(z3.gt(0)),
  balanceType: z3.enum(["cash", "visa", "wallet"]),
  notes: z3.optional(z3.string()),
  date: z3.number()
});
var listSupplierPaymentsInput = z3.object({
  supplierId: z3.optional(z3.number()),
  startDate: z3.optional(z3.number()),
  endDate: z3.optional(z3.number()),
  cursor: z3.optional(z3.object({ date: z3.number(), id: z3.number() })),
  limit: z3.optional(z3.number())
});
var transferFromWalletInput = z3.object({
  // amount got out of our balance
  outAmount: z3.number().check(z3.gt(0)),
  // amount got into our balance
  inAmount: z3.number().check(z3.gt(0)),
  // which balance type
  balanceType: z3.enum(["cash", "visa"]),
  notes: z3.optional(z3.string()),
  createdAt: z3.optional(z3.number())
});
var transferToWalletInput = z3.omit(transferFromWalletInput, { balanceType: true });
var manualTransactionInput = z3.object({
  type: z3.enum(["deposit", "withdraw"]),
  amount: z3.number().check(z3.gt(0)),
  balanceType: z3.enum(["cash", "visa", "wallet"]),
  notes: z3.optional(z3.string()),
  date: z3.optional(z3.number())
});
var loginInput = z3.object({
  username: z3.string().check(z3.includes("@")),
  password: z3.string().check(z3.minLength(4))
});
var listCustomersInput = z3.object({
  filter: z3.optional(
    z3.object({
      phone: z3.optional(z3.string()),
      name: z3.optional(z3.string())
    })
  ),
  cursor: z3.optional(z3.number()),
  limit: z3.optional(z3.number())
});
var createCustomerInput = z3.object({
  name: z3.string(),
  phoneNumbers: z3.optional(
    z3.array(
      z3.object({
        id: z3.optional(z3.number()),
        phone: z3.string().check(z3.startsWith("01"), z3.length(11)),
        primary: z3.boolean()
      })
    )
  )
});
var editCustomerInput = z3.extend(createCustomerInput, { id: z3.number() });
var createSupplierInput = z3.object({
  name: z3.string().check(z3.minLength(1, "Name is required")),
  phones: z3.optional(z3.array(z3.object({ phone: z3.string() }))),
  notes: z3.optional(z3.string()),
  brandIds: z3.optional(z3.array(z3.number()))
});
var editSupplierInput = z3.extend(createSupplierInput, { id: z3.number() });
var notificationMessageInput = z3.object({
  title: z3.string().check(z3.minLength(1), z3.maxLength(100)),
  body: z3.string().check(z3.minLength(1), z3.maxLength(500))
});
var customerAudience = z3.object({
  audience: z3.literal("customer"),
  customerId: z3.number()
});
var allAudience = z3.object({ audience: z3.literal("all") });
var registeredAudience = z3.object({ audience: z3.literal("registered") });
var unregisteredAudience = z3.object({ audience: z3.literal("unregistered") });
var groupAudience = z3.object({
  audience: z3.literal("group"),
  groupId: z3.number()
});
var previewAudienceInput = z3.discriminatedUnion("audience", [
  customerAudience,
  allAudience,
  registeredAudience,
  unregisteredAudience,
  groupAudience
]);
var sendNotificationInput = z3.discriminatedUnion("audience", [
  z3.object({ ...customerAudience.shape, ...notificationMessageInput.shape }),
  z3.object({ ...allAudience.shape, ...notificationMessageInput.shape }),
  z3.object({ ...registeredAudience.shape, ...notificationMessageInput.shape }),
  z3.object({ ...unregisteredAudience.shape, ...notificationMessageInput.shape }),
  z3.object({ ...groupAudience.shape, ...notificationMessageInput.shape })
]);
var listNotificationHistoryInput = z3.object({
  cursor: z3.optional(z3.number()),
  limit: z3.optional(z3.number())
});
var createNotificationGroupInput = z3.object({
  name: z3.string().check(z3.minLength(1), z3.maxLength(100))
});
var updateNotificationGroupInput = z3.object({
  id: z3.number(),
  name: z3.string().check(z3.minLength(1), z3.maxLength(100))
});
var deleteNotificationGroupInput = z3.object({ id: z3.number() });
var notificationGroupMembersInput = z3.object({
  groupId: z3.number(),
  customerIds: z3.array(z3.number()).check(z3.minLength(1))
});
var listCustomerTransactionsInput = z3.object({
  id: z3.number(),
  cursor: z3.optional(z3.number()),
  limit: z3.optional(z3.number())
});
var customerTransactionInput = z3.object({
  type: z3.enum(CustomerTransactionType),
  customerId: z3.number(),
  amount: z3.number(),
  note: z3.optional(z3.string()),
  date: z3.optional(z3.number()),
  method: z3._default(z3.enum(PaymentMethod), PaymentMethod.cash),
  receiptRef: z3.optional(z3.string())
});
var singleProductMovementInput = z3.object({
  storagePlaceId: z3.number(),
  productIds: z3._default(z3.array(z3.number()), []),
  from: z3.number(),
  // unix seconds
  to: z3.number()
  // unix seconds
});
var trackProductInput = z3.object({
  productIds: z3.array(z3.number()),
  storagePlaceId: z3.optional(z3.number()),
  from: z3.optional(z3.number()),
  // utc unix
  to: z3.optional(z3.number()),
  // utc unix
  limit: z3.optional(z3._default(z3.number(), 50)),
  cursor: z3.optional(z3.number())
  // For pagination (movement ID)
});
var MovementTypeEnum = ["SALE", "RESTOCK", "ADJUSTMENT", "RETURN"];
var adjustStockInput = z3.object({
  productId: z3.number(),
  storagePlaceId: z3.number(),
  newQuantity: z3.coerce.number().check(z3.minimum(0)),
  reason: z3.optional(z3.string())
});
var listAdjustmentsInput = z3.object({
  from: z3.optional(z3.number()),
  // utc unix
  to: z3.optional(z3.number()),
  // utc unix
  limit: z3.optional(z3._default(z3.number(), 25)),
  cursor: z3.optional(z3.number())
  // movement id (descending keyset)
});
var updateLowStockThresholdInput = z3.object({
  productId: z3.number(),
  storagePlaceId: z3.number(),
  lowStockThreshold: z3.nullable(z3.number().check(z3.minimum(0)))
});
var inventoryReportInput = z3.object({
  storagePlaceId: z3.number(),
  from: z3.number(),
  to: z3.number(),
  collectionId: z3.optional(z3.number()),
  productId: z3.optional(z3.number()),
  productIds: z3.optional(z3.array(z3.number()).check(z3.maxLength(200)))
});
var weightDefinedProductInput = z3.object({
  baseProductId: z3.number(),
  name: z3.string().check(z3.minLength(3)),
  weight: z3.number().check(z3.int(), z3.minimum(1), z3.maximum(99999)),
  // grams
  price: z3.number().check(z3.int(), z3.minimum(0)),
  originalPrice: z3.optional(z3.number().check(z3.int(), z3.minimum(0)))
});
var createWeightDefinedInput = z3.object({
  baseProductId: z3.number(),
  weight: z3.number().check(z3.int(), z3.gt(0)),
  status: z3.optional(z3.enum(["active", "inactive"]))
});
var scaleProductFormInput = z3.object({
  name: z3.string().check(z3.minLength(3)),
  description: z3.optional(z3.string()),
  code: z3.number().check(z3.int(), z3.minimum(1), z3.maximum(99999)),
  // PLU code 1-99999, converts to UPC 20XXXXX
  brandId: z3.optional(z3.number()),
  price: z3.number().check(z3.int(), z3.minimum(0)),
  // price per kg in milli-units
  originalPrice: z3.optional(z3.number().check(z3.int(), z3.minimum(0)))
});
var _salesDetailsShiftMode = z3.object({
  shiftId: z3.number(),
  cursor: z3.optional(z3.number())
});
var _salesDetailsDateRangeMode = z3.object({
  from: z3.number(),
  to: z3.number(),
  cursor: z3.optional(z3.number())
}).check(z3.refine((val) => val.to >= val.from, "to must be >= from"));
var salesDetailsInput = z3.union([_salesDetailsShiftMode, _salesDetailsDateRangeMode]);
var imageInput = zfd.formData({
  thumbhash: z3.optional(z3.string()),
  entity: z3.enum(ImageEntity),
  entityId: z3.coerce.number(),
  image: z3.pipe(
    z3.instanceof(File),
    z3.custom((file) => {
      if (file.size > 262144) return "Image must be less than 256KB";
      if (!file.type.startsWith("image/")) return "Invalid file type \u2014 must be an image";
      return true;
    })
  )
});
var uploadImageBySku = z3.object({
  thumbhash: z3.string(),
  sku: z3.string(),
  imageUrl: z3.url(),
  brand: z3.string()
});
var returnItemInput = z3.object({
  productId: z3.number(),
  upc: z3.string(),
  returnQuantity: z3.number().check(z3.minimum(1)),
  returnWeight: z3.optional(z3.number())
});
var processReturnInput = z3.object({
  receiptId: z3.optional(z3.number()),
  orderId: z3.optional(z3.number()),
  items: z3.array(returnItemInput).check(z3.minLength(1)),
  refundMethod: z3._default(z3.enum(PaymentMethod), "cash"),
  reason: z3.string().check(z3.minLength(3)),
  customerId: z3.optional(z3.number())
});
var returnListInput = z3.object({
  status: z3.optional(z3.enum(CustomerReturnStatus)),
  from: z3.optional(z3.number()),
  to: z3.optional(z3.number()),
  cursor: z3.optional(z3.number()),
  limit: z3.optional(z3.number())
});

// src/inventory-collections.ts
import * as z4 from "zod/mini";
var createInventoryCollectionInput = z4.object({
  name: z4.string().check(z4.minLength(1, "Name is required"))
});
var identifyInventoryCollectionInput = z4.object({
  id: z4.number()
});
var listInventoryCollectionsInput = z4.object({
  cursor: z4.optional(z4.object({ id: z4.number(), rank: z4.number(), updatedAt: z4.optional(z4.number()) })),
  limit: z4._default(z4.number(), 50),
  search: z4.optional(z4.string())
});

// src/menu.ts
import { z as z5 } from "zod/v4-mini";
var createAnnouncementInput = z5.object({
  title: z5.optional(z5.string()),
  description: z5.optional(z5.string()),
  entity: z5.enum(announcementEntity),
  entityId: z5.number(),
  status: z5.prefault(z5.enum(Status), Status.active)
});
var createSectionInput = z5.object({
  name: z5.string(),
  status: z5.prefault(z5.enum(Status), Status.active)
});
var createCollectionInput = z5.object({
  name: z5.string(),
  sectionId: z5.number(),
  status: z5.prefault(z5.enum(Status), Status.active)
});
var linkCollectionsToSectionInput = z5.object({
  sectionId: z5.number(),
  collectionIds: z5.array(z5.number())
});
var linkProductsToCollectionInput = z5.object({
  collectionId: z5.number(),
  productIds: z5.array(z5.number())
});

// src/market.ts
import { z as z6 } from "zod/v4-mini";
var zPhone = z6.string().check(z6.trim(), z6.length(11), z6.regex(/^01[0125]\d{8}$/));
var customerLoginInput = z6.object({
  phone: zPhone
});
var customerCompleteProfileInput = z6.object({ name: z6.string().check(z6.minLength(2)) });
var verifyOtpInput = z6.object({
  phone: zPhone,
  sessionId: z6.string(),
  otp: z6.string().check(z6.length(4), z6.regex(/^\d{4}$/))
});

// src/order.ts
import { z as z7 } from "zod/v4-mini";
var placeOrderInput = z7.object({
  addressId: z7.number(),
  deliveryInstructions: z7.optional(z7.string()),
  items: z7.array(
    z7.object({
      productId: z7.number(),
      quantity: z7.number().check(z7.positive())
    })
  ).check(z7.minLength(1))
});
var updateOrderStatusInput = z7.object({
  orderId: z7.number(),
  status: z7.enum(OrderStatus),
  rejectionReason: z7.optional(z7.string())
});
var getOrderInput = z7.object({
  id: z7.number()
});
var listOrdersInput = z7.object({
  limit: z7._default(z7.optional(z7.number()), 20),
  offset: z7._default(z7.optional(z7.number()), 0)
});
var listOrdersAdminInput = z7.object({
  limit: z7._default(z7.optional(z7.number()), 10),
  offset: z7._default(z7.optional(z7.number()), 0),
  cursor: z7.optional(z7.number()),
  status: z7.optional(z7.array(z7.enum(OrderStatus))),
  source: z7.optional(z7.array(z7.enum(OrderSource))),
  orderNumber: z7.optional(z7.string()),
  customerId: z7.optional(z7.number())
});
var createOrderAdminInput = z7.object({
  customerId: z7.number(),
  addressId: z7.number(),
  source: z7.enum(OrderSource),
  items: z7.array(
    z7.object({
      productId: z7.number(),
      quantity: z7.number().check(z7.positive())
    })
  ).check(z7.minLength(1)),
  deliveryInstructions: z7.optional(z7.string()),
  discount: z7._default(z7.optional(z7.number()), 0)
});
var updateOrderInput = z7.object({
  id: z7.number(),
  items: z7.optional(
    z7.array(
      z7.object({
        productId: z7.number(),
        quantity: z7.number().check(z7.positive())
      })
    )
  ),
  addressId: z7.optional(z7.number()),
  discount: z7._default(z7.optional(z7.number()), 0)
});
var updateOrderStatusAdminInput = z7.object({
  id: z7.number(),
  status: z7.enum(OrderStatus),
  rejectionReason: z7.optional(z7.string())
});

// src/address.ts
import { z as z8 } from "zod/v4-mini";
var newAddressInput = z8.object({
  label: z8.string().check(z8.minLength(1)),
  areaId: z8.number(),
  lat: z8.optional(z8.number()),
  lng: z8.optional(z8.number()),
  details: z8.optional(z8.string()),
  building: z8.optional(z8.string()),
  floor: z8.optional(z8.string()),
  flat: z8.optional(z8.string()),
  instructions: z8.optional(z8.string())
});
var editAddressInput = z8.extend(newAddressInput, { id: z8.number() });

// src/config.ts
import { z as z9 } from "zod/v4-mini";
var channelSchema = z9.enum(["development", "staging", "production"]);
var configSchema = z9.object({
  maintenance: z9.prefault(z9.boolean(), false),
  busy: z9.prefault(z9.boolean(), false),
  message: z9.prefault(z9.nullable(z9.string()), null),
  version: z9.object({ latest: z9.string(), minimum: z9.string() }),
  storeLink: z9.object({ android: z9.string(), ios: z9.string() })
});
export {
  CustomerTransactionType,
  EMPLOYEE_ROLES,
  Event,
  ImageEntity,
  InboxType,
  MovementType,
  MovementTypeEnum,
  OrderSource,
  OrderStatus,
  PaymentMethod,
  ProductType,
  Status,
  TransactionTypeEnum,
  _productFormInput,
  addEmployeeBalanceInput,
  adjustStockInput,
  channelSchema,
  configSchema,
  confirmShiftInput,
  createAnnouncementInput,
  createCollectionInput,
  createCustomerInput,
  createEmployeeInput,
  createExpenseCategoryInput,
  createExpenseInput,
  createInventoryCollectionInput,
  createNotificationGroupInput,
  createOrderAdminInput,
  createReceiptInput,
  createSectionInput,
  createShiftInput,
  createSupplierInput,
  createSupplierPaymentInput,
  createWeightDefinedInput,
  customerCompleteProfileInput,
  customerLoginInput,
  customerTransactionInput,
  deleteEmployeeInput,
  deleteNotificationGroupInput,
  deleteShiftInput,
  editAddressInput,
  editCustomerInput,
  editMenuSettingsInput,
  editSupplierInput,
  employeePayment,
  endShiftInput,
  enumValues,
  expoImage,
  getEmployeeInput,
  getOrderInput,
  getProductByUpcInput,
  getProductInput,
  getProductMultiple,
  getShiftInput,
  identifyInventoryCollectionInput,
  identifyPos,
  imageInput,
  ingestBatchInput,
  inventoryReportInput,
  itemInput,
  linkCollectionsToSectionInput,
  linkProductsToCollectionInput,
  listAdjustmentsInput,
  listCustomerTransactionsInput,
  listCustomersInput,
  listDenormalizedProductsInput,
  listInventoryCollectionsInput,
  listNotificationHistoryInput,
  listOrdersAdminInput,
  listOrdersInput,
  listProductsByStoragePlaceInput,
  listProductsInput,
  listShiftInput,
  listSupplierPaymentsInput,
  loginInput,
  lookupInput,
  manualTransactionInput,
  newAddressInput,
  normalizeProductInput,
  notificationGroupMembersInput,
  notificationMessageInput,
  placeOrderInput,
  posLoginInput,
  previewAudienceInput,
  processReturnInput,
  productEditFormInput,
  productFormInput,
  productFormSchema,
  purchaseTransactionFormSchema,
  returnItemInput,
  returnListInput,
  salesDetailsInput,
  scaleProductFormInput,
  sendNotificationInput,
  shiftRangeInput,
  singleProductMovementInput,
  startShiftInput,
  syncChangesInput,
  trackProductInput,
  transactionListInput,
  transferFromWalletInput,
  transferToWalletInput,
  updateEmployeeInput,
  updateLowStockThresholdInput,
  updateNotificationGroupInput,
  updateOrderInput,
  updateOrderStatusAdminInput,
  updateOrderStatusInput,
  updateShiftInput,
  uploadImageBySku,
  verifyOtpInput,
  weightDefinedProductInput,
  z10 as z
};
